module.exports = __webpack_public_path__ + "24a52bf5de3b742a202ed48c24d8aaf2.jpg";